import React, { useMemo } from 'react';
import { forwardRef } from 'react';

import Dot from '../Dot';
import Stack from '../Stack';
import { DotSeparatorProps } from './types';
import { getChildrenWithProps } from './utils';

export const DotSeparator = forwardRef<HTMLDivElement, DotSeparatorProps>((props, forwardedRef) => {
  const { children, dotProps, typographyProps, ...rest } = props;

  const childrenWithProps = useMemo(
    () => getChildrenWithProps(children, typographyProps),
    [children, typographyProps],
  );

  return (
    <Stack
      ref={forwardedRef}
      alignItems="center"
      divider={<Dot spacing="mx-0" {...dotProps} />}
      {...rest}>
      {childrenWithProps}
    </Stack>
  );
});

export default React.memo(DotSeparator);
